export const timezones = [
  "Eastern Time (US & Canada)",
  "Central Time (US & Canada)",
  "Mountain Time (US & Canada)",
  "Arizona",
  "Pacific Time (US & Canada)",
  "Alaska",
  "Hawaii",
  "UTC"
]